import React from "react";
import { MoreOutlined } from "@ant-design/icons";
import styles from "../../styles.less";

const OriginToDestination = props => {
  const { record } = props;

  return (
    <div
      className="orig-to-dest"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <div className={styles["landingPageTableData"]}>{record.pickUpAddress}</div>
      <MoreOutlined
        style={{
          position: "relative",
          right: 4,
          paddingTop: "1%",
          paddingBottom: "1%",
        }}
      />
      <div className={styles["landingPageTableData"]}>{record.dropOffAddress}</div>
    </div>
  );
};

export default OriginToDestination;
